import { render } from "./DispensaOleos.vue?vue&type=template&id=390535e9&scoped=true"
import script from "./DispensaOleos.vue?vue&type=script&lang=js"
export * from "./DispensaOleos.vue?vue&type=script&lang=js"

import "./DispensaOleos.vue?vue&type=style&index=0&id=390535e9&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390535e9"]])

export default __exports__